// extracted by mini-css-extract-plugin
module.exports = {"container":"GetAndGift_container__1xfUf","cardList":"GetAndGift_cardList__1ut9z"};